import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { GRID_SM_PX } from '../../../styles';



export const SloganDesc = () => {
  const { t } = useTranslation();
  return (
    <SecondText>
      {t('header.subtitle')}
    </SecondText>
  );
};


export const SecondText = styled.h1`
   font-size: 18px;
   font-weight: 500;
   @media only screen and (max-width: ${GRID_SM_PX}) {
      font-size: 14px;
    }
`;